import React from 'react';
import { useTranslation } from 'next-i18next';
import './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import './index-dEXHnASi.js';
import 'next/router';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import { handleLeadingZeros } from './utils/product.js';
import './helpers-WYINLSKJ.js';
import 'lodash';

const Counter = ({ value, disabled, setValue, maxCount, counterButtons }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const showErrorNotify = useShowError();
    const clickHandler = (operation, inputValue) => {
        if (operation === 'inc') {
            if (maxCount !== undefined) {
                if (!maxCount || inputValue <= maxCount) {
                    setValue(inputValue);
                }
            }
            else {
                setValue(inputValue);
            }
        }
        if (operation === 'dec') {
            if (inputValue >= 1) {
                setValue(inputValue);
            }
            else {
                showErrorNotify(t('$common.$validation.minimumQuantity'));
            }
        }
    };
    const onInputHandler = (e) => {
        let inputValueString = e.currentTarget.value;
        if (inputValueString.charAt(0) === '0') {
            inputValueString = inputValueString.substring(1);
        }
        const inputValue = Number(inputValueString);
        if (Number(inputValue) < 0) {
            setValue(Math.abs(Number(inputValue)));
        }
        else {
            setValue(inputValue);
        }
    };
    const onkeydownHandler = (e) => {
        if (e.key === 'e' || e.key === '-' || e.key === '.') {
            e.preventDefault();
        }
    };
    const onBlurHandler = () => {
        if (!value)
            setValue(1);
    };
    const onFocusHandler = (e) => {
        e.target.select();
    };
    return (React.createElement("div", { className: "quantity-counter" },
        counterButtons ? (React.createElement("button", { className: "quantity-counter-btn minus", type: "button", onClick: () => clickHandler('dec', Number(value) - 1), "aria-label": t('$common.quantityDecrease'), disabled: disabled || value <= 1 },
            React.createElement("span", null, "-"))) : (React.createElement("div", { className: "quantity-counter-label" },
            tLabel('qty'),
            ":")),
        React.createElement("input", { type: "number", pattern: "\\d*" // only numbers
            , name: "quantity", min: 1, value: handleLeadingZeros(value), className: "quantity-counter-input", onBlur: onBlurHandler, onKeyDown: onkeydownHandler, onInput: onInputHandler, "aria-label": t('$common.quantityInput'), disabled: disabled, onFocus: onFocusHandler }),
        counterButtons && (React.createElement("button", { className: "quantity-counter-btn plus", type: "button", onClick: () => clickHandler('inc', Number(value) + 1), "aria-label": t('$common.quantityIncrease'), disabled: disabled },
            React.createElement("span", null, "+")))));
};

export { Counter as C };
//# sourceMappingURL=Counter-1FiHQxtY.js.map
